import { queryOptions, useQuery } from '@tanstack/react-query'
import { fetchCouponCode } from '@/features/authentication/services/SignupPromotions/fetchers'
import { type ParsedUrlQuery } from 'node:querystring'
import { useSearchQueryParams } from '@/features/shared/hooks/search'

/**
 * useQueryCouponCode
 */
export const couponCodeQueryOptions = (queryParams: ParsedUrlQuery) => {
  const { gift_code } = queryParams
  return queryOptions({
    queryKey: ['Coupon Code', { gift_code: String(gift_code) }] as const,
    queryFn: fetchCouponCode,
  })
}
export type CouponCodeQueryKey = readonly [string, { gift_code: string }]

export const useQueryCouponCode = () => {
  const searchParams = useSearchQueryParams()
  const { gift_code } = searchParams

  return useQuery({
    ...couponCodeQueryOptions(searchParams),
    enabled: Boolean(gift_code),
    refetchOnWindowFocus: false,
  })
}
